// ----- ROUTES CONFIGURATION ----- //
export const IMPERSONATE_LOGIN_ROUTE = "/abracadabra";
export const IMPERSONATE_GRANT_ROUTE = "/impersonate-grant";
export const AUTO_LOGIN_ROUTE = "/auto-login";

export const VOUCHER_AND_BALANCE_TAB_VALUES = [
  "employees",
  "top-ups",
  "balance",
] as const;
export type VoucherAndBalanceTabValue =
  (typeof VOUCHER_AND_BALANCE_TAB_VALUES)[number];
export const VOUCHER_ORDERS_PAGE_PATH = "/titres-cadeaux";
export const VOUCHER_EMPLOYEES_PATH = `${VOUCHER_ORDERS_PAGE_PATH}/titres`;
export const VOUCHER_TOP_UPS_PATH = `${VOUCHER_ORDERS_PAGE_PATH}/flux-crediteur-cse`;
export const VOUCHER_BALANCE_PATH = `${VOUCHER_ORDERS_PAGE_PATH}/bons-de-commande`;

export const VOUCHER_CAMPAIGN_PATH = "/titres-cadeaux/creer-titres-cadeaux";
export const VOUCHER_CAMPAIGN_EMPLOYEES_PATH = `${VOUCHER_CAMPAIGN_PATH}/:id/salaries`;
export const VOUCHER_CAMPAIGN_BENEFICIARIES_PATH = `${VOUCHER_CAMPAIGN_PATH}/:id/ayants-droit`;
export const VOUCHER_CAMPAIGN_MCC_PATH = `${VOUCHER_CAMPAIGN_PATH}/:id/mcc`;

// Cartes cadeaux (checks)
export const CHECK_TAB_VALUES = ["campaigns", "employees", "contributions"] as const;
export type CheckTabValue = (typeof CHECK_TAB_VALUES)[number];
export const CHECKS_PAGE_PATH = "/cartes-cadeaux";
export const CHECK_CAMPAIGNS_PATH = `${CHECKS_PAGE_PATH}/campagnes`;
export const CHECK_CAMPAIGN_EMPLOYEES_PATH = `${CHECK_CAMPAIGNS_PATH}/:id/salaries`;
export const CHECK_CAMPAIGN_BENEFICIARIES_PATH = `${CHECK_CAMPAIGNS_PATH}/:id/ayants-droit`;
export const CHECK_EMPLOYEES_PATH = `${CHECKS_PAGE_PATH}/cartes-emises`;
export const CHECK_CONTRIBUTIONS_PATH = `${CHECKS_PAGE_PATH}/abondements`;
export const getCheckCampaignEmployeesPath = (id: string) =>
  `${CHECK_CAMPAIGNS_PATH}/${id}/salaries`;
export const getCheckCampaignBeneficiariesPath = (id: string) =>
  `${CHECK_CAMPAIGNS_PATH}/${id}/ayants-droit`;

export const EMPLOYEES_PAGE_PATH = "/salaries";
export const EMPLOYEE_TRANSFER_PAGE_PATH = "/salaries/transferts";
export const BENEFICIARIES_PAGE_PATH = "/ayants-droit";
export const REPRESENTATIVES_PAGE_PATH = "/elus";
export const REPRESENTATIVES_DIRECTORY_PAGE_PATH = "/trombinoscope";
export const EXTERNAL_CONTACTS_PAGE_PATH = "/contacts";
export const SUPPLIERS_PAGE_PATH = "/entreprises";
export const JOBS_PAGE_PATH = "/taches";
export const GROUPS_PAGE_PATH = "/groupes";
export const GROUP_NEW_PATH = `${GROUPS_PAGE_PATH}/nouveau`;
export const GROUP_EDIT_PATH = `${GROUPS_PAGE_PATH}/:groupId`;
export const getGroupEditPath = (groupId: string) => `${GROUPS_PAGE_PATH}/${groupId}`;

/** Dynamic group builder routes */
export const DYNAMIC_GROUP_BUILDER_BASE = `${GROUPS_PAGE_PATH}/dynamique`;
export const DYNAMIC_GROUP_NEW_PATH = `${DYNAMIC_GROUP_BUILDER_BASE}/nouveau`;
export const DYNAMIC_GROUP_EDIT_PATH = `${DYNAMIC_GROUP_BUILDER_BASE}/:groupId`;
export const getDynamicGroupEditPath = (groupId: string) =>
  `${DYNAMIC_GROUP_BUILDER_BASE}/${groupId}`;
export const POLLS_PAGE_PATH = "/sondages";
export const POLL_RESULTS_PAGE_PATH = `${POLLS_PAGE_PATH}/:pollId/resultats`;
export const getPollResultsPath = (pollId: string) =>
  `${POLLS_PAGE_PATH}/${pollId}/resultats`;
export const SURVEYS_PAGE_PATH = "/enquetes";
export const SURVEY_DETAIL_PATH = `${SURVEYS_PAGE_PATH}/:surveyId`;
export const getSurveyDetailPath = (surveyId: string) =>
  `${SURVEYS_PAGE_PATH}/${surveyId}`;
export const SURVEY_CREATE_PATH = `${SURVEYS_PAGE_PATH}/nouvelle`;
export const SURVEY_EDIT_PATH = `${SURVEYS_PAGE_PATH}/:surveyId/modifier`;
export const getSurveyEditPath = (surveyId: string) =>
  `${SURVEYS_PAGE_PATH}/${surveyId}/modifier`;
export const SURVEY_DUPLICATE_PARAM = "duplicateFrom";
export const getSurveyDuplicatePath = (surveyId: string) =>
  `${SURVEY_CREATE_PATH}?${SURVEY_DUPLICATE_PARAM}=${encodeURIComponent(surveyId)}`;
export const BLOG_PAGE_PATH = "/blog";
export const BLOG_ARTICLE_PATH = `${BLOG_PAGE_PATH}/:articleId`;
export const getBlogArticlePath = (articleId: string) =>
  `${BLOG_PAGE_PATH}/${articleId}`;
export const BLOG_NEW_ARTICLE_PATH = `${BLOG_PAGE_PATH}/nouvel-article`;
export const BLOG_EDIT_ARTICLE_PAGE_PATH = `${BLOG_PAGE_PATH}/article/:articleId/modifier`;
export const getBlogEditArticlePath = (articleId: string) =>
  `${BLOG_PAGE_PATH}/article/${articleId}/modifier`;
export const PRONOSTICS_PAGE_PATH = "/pronostics";
export const PRONOSTIC_COMPETITION_DETAIL_PATH = `${PRONOSTICS_PAGE_PATH}/:competitionId`;
export const getPronosticCompetitionDetailPath = (competitionId: string) =>
  `${PRONOSTICS_PAGE_PATH}/${competitionId}`;

export const TOMBOLA_PAGE_PATH = "/tombola";
export const TOMBOLA_NEW_PATH = `${TOMBOLA_PAGE_PATH}/new`;
export const TOMBOLA_DASHBOARD_PATH = `${TOMBOLA_PAGE_PATH}/:lotteryId`;
export const getTombolaDashboardPath = (lotteryId: string) =>
  `${TOMBOLA_PAGE_PATH}/${lotteryId}`;

export const ADVENT_CALENDAR_PAGE_PATH = "/advent-calendar";
export const ADVENT_CALENDAR_DASHBOARD_PATH = `${ADVENT_CALENDAR_PAGE_PATH}/:calendarId`;
export const getAdventCalendarDashboardPath = (calendarId: string) =>
  `${ADVENT_CALENDAR_PAGE_PATH}/${calendarId}`;

export const ARCADE_PAGE_PATH = "/arcade";
export const ARCADE_GAME_PATH = `${ARCADE_PAGE_PATH}/jeux/:instanceId`;
export const getArcadeGamePath = (instanceId: string) => `${ARCADE_PAGE_PATH}/jeux/${instanceId}`;
export const ARCADE_COMPETITION_PATH = `${ARCADE_PAGE_PATH}/competitions/:competitionId`;
export const getArcadeCompetitionPath = (competitionId: string) =>
  `${ARCADE_PAGE_PATH}/competitions/${competitionId}`;

export const CARD_REISSUANCE_PATH = "/reeditiondecarte";
export const CARD_REISSUANCE_ORDER_PATH = `${CARD_REISSUANCE_PATH}/commande`;

export const PARAMETER_PATH = "/parametres";
export const PARAMETER_IDENTITE_CSE_PATH = `${PARAMETER_PATH}/identite-du-cse`;
export const PARAMETER_STUDIO_PATH = `${PARAMETER_PATH}/studio`;
export const PARAMETER_PERSONNALISATION_PATH = `${PARAMETER_STUDIO_PATH}/personnalisation`;
export const PARAMETER_COORDONNEES_PATH = `${PARAMETER_PATH}/coordonnees`;
export const PARAMETER_INFORMATIONS_PATH = `${PARAMETER_PATH}/informations`;
export const PARAMETER_SITES_PATH = `${PARAMETER_PATH}/gestion-des-sites`;
export const PARAMETER_DATA_MANAGEMENT_PATH = `${PARAMETER_PATH}/gestion-des-donnees`;
export const PARAMETER_WELCOME_EMAIL_PATH = `${PARAMETER_PATH}/email-bienvenue`;
export const PARAMETER_WELCOME_EMAIL_NEW_PATH = `${PARAMETER_WELCOME_EMAIL_PATH}/new`;
export const PARAMETER_WELCOME_EMAIL_EDITOR_PATH = `${PARAMETER_WELCOME_EMAIL_PATH}/:id/edit`;
export const getWelcomeEmailEditorPath = (id: string) =>
  `${PARAMETER_WELCOME_EMAIL_PATH}/${id}/edit`;
export const PARAMETER_BENEFICIARIES_PATH = `${PARAMETER_PATH}/ayants-droit`;
export const PARAMETER_PROOF_DOCUMENTS_PATH = `${PARAMETER_PATH}/justificatifs`;
export const PARAMETER_REPRESENTATIVE_ROLES_PATH = `${PARAMETER_PATH}/representative-roles`;
export const PARAMETER_SUBSCRIPTION_INVOICES_PATH = `${PARAMETER_PATH}/factures`;
export const PARAMETER_DIRECT_DEBIT_PATH = `${PARAMETER_PATH}/prelevement`;
export const PARAMETER_DASHBOARD_LAYOUTS_PATH = `${PARAMETER_STUDIO_PATH}/tableaux-de-bord`;
export const PARAMETER_NAV_POSITION_PATH = `${PARAMETER_STUDIO_PATH}/menu`;
export const PARAMETER_THEMES_PATH = `${PARAMETER_STUDIO_PATH}/themes`;
export const PARAMETER_COLORS_PATH = `${PARAMETER_STUDIO_PATH}/couleurs`;
export const PARAMETER_THEME_PATH = `${PARAMETER_STUDIO_PATH}/theme`;
export const PARAMETER_BANNERS_PATH = `${PARAMETER_STUDIO_PATH}/bannieres`;
export const PARAMETER_VOUCHERS_SETTINGS_PATH = `${PARAMETER_STUDIO_PATH}/bons`;
export const PARAMETER_MOBILE_APP_PATH = `${PARAMETER_STUDIO_PATH}/application-mobile`;
export const PARAMETER_THEME_DETAIL_PATH = `${PARAMETER_THEMES_PATH}/:themeId`;
export const getThemeDetailPath = (themeId: string) => `${PARAMETER_THEMES_PATH}/${themeId}`;
export const getThemeDetailSubPath = (themeId: string, sub: string) => `${PARAMETER_THEMES_PATH}/${themeId}/${sub}`;
export const EMAIL_ORGANIZATION_SIGNATURE_PATH = "/signature-email";
export const PARAMETER_EMAIL_SIGNATURE_PATH = `${PARAMETER_PATH}${EMAIL_ORGANIZATION_SIGNATURE_PATH}`;
export const PARAMETER_MODULES_CONFIG_PATH = `${PARAMETER_PATH}/config-modules`;

// Custom Forms (standalone feature)
export const CUSTOM_FORMS_PAGE_PATH = "/formulaires";
export const CUSTOM_FORM_NEW_PATH = `${CUSTOM_FORMS_PAGE_PATH}/nouveau`;
export const CUSTOM_FORM_EDIT_PATH = `${CUSTOM_FORMS_PAGE_PATH}/:formId`;
export const getCustomFormEditPath = (formId: string) => `${CUSTOM_FORMS_PAGE_PATH}/${formId}`;
export const CUSTOM_FORM_SUBMISSIONS_PATH = `${CUSTOM_FORMS_PAGE_PATH}/:formId/reponses`;
export const getCustomFormSubmissionsPath = (formId: string) => `${CUSTOM_FORMS_PAGE_PATH}/${formId}/reponses`;

export const USER_SETTINGS_PATH = "/user/settings";
export const USER_EMAIL_SIGNATURE_PATH = `${USER_SETTINGS_PATH}/signature`;
export const USER_NOTIFICATIONS_PATH = `${USER_SETTINGS_PATH}/notifications`;
export const USER_LINK_ACCOUNTS_PATH = `${USER_SETTINGS_PATH}/rattacher-comptes`;

export const PINNED_NOTES_PATH = "/pinned-notes";
export const DISCUSSIONS_PAGE_PATH = "/discussions";
export const AUDIT_LOGS_PAGE_PATH = "/audit-logs";
export const FILE_MANAGER_PATH = "/gestionnaire-fichiers";
export const FILE_MANAGER_FOLDER_PATH = `${FILE_MANAGER_PATH}/dossier/:folderId`;
export const getFileManagerFolderPath = (folderId: string) =>
  `${FILE_MANAGER_PATH}/dossier/${folderId}`;
export const FILE_PREVIEW_TEST_PATH = "/test-apercus-office";

export const CALENDAR_PATH = "/calendrier";
export const REFUND_REQUESTS_PAGE_PATH = "/remboursements";
export const REFUND_REQUEST_DETAIL_PATH = "/remboursements/:requestId";
export const PROOF_DOCUMENTS_PAGE_PATH = "/proof_documents";
export const ACCOUNTING_MOVEMENTS_PAGE_PATH = "/accounting/ledger/movements";
export const BRIDGE_CALLBACK_PAGE_PATH = "/accounting/bridge/callback";
export const LEGACY_ACCOUNTING_MOVEMENTS_PAGE_PATH = "/compta/livre/mouvements";
export const ACCOUNTING_SETTLEMENTS_PAGE_PATH = "/accounting/ledger/settlements";
export const LEGACY_ACCOUNTING_SETTLEMENTS_PAGE_PATH = "/compta/livre/cheques-crediteurs";
export const ACCOUNTING_LEDGER_PAGE_PATH = "/accounting/ledger/grand-livre";
export const ACCOUNTING_STOCK_PAGE_PATH = "/accounting/ledger/stock";
export const ACCOUNTING_SYNTHESIS_PAGE_PATH = "/accounting/ledger/synthesis";
// YTI-1732 : les remises de virements SEPA (réédition, régénération, annulation).
export const ACCOUNTING_SEPA_REMITTANCES_PAGE_PATH = "/accounting/ledger/sepa-remittances";
export const ACCOUNTING_SEPA_HELP_PAGE_PATH = `${ACCOUNTING_SEPA_REMITTANCES_PAGE_PATH}/aide`;
// ADM-621 : budgets prévisionnels par millésime + gestion des catégories.
export const ACCOUNTING_BUDGET_PAGE_PATH = "/accounting/budget";
export const ACCOUNTING_SETTINGS_PAGE_PATH = "/accounting/settings";
// ADM-621 : les paramètres compta passent en sections, comme les paramètres CSE.
export const ACCOUNTING_SETTINGS_FISCAL_YEAR_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/exercice`;
export const ACCOUNTING_SETTINGS_BANK_ACCOUNTS_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/comptes-bancaires`;
export const ACCOUNTING_SETTINGS_BRIDGE_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/synchronisation-bancaire`;
export const ACCOUNTING_SETTINGS_PAYBOX_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/paiement-en-ligne`;
export const ACCOUNTING_SETTINGS_TAGS_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/tags`;
// Guides élus de la compta : budgets, paramètres (exercice et comptes), synchronisation bancaire,
// saisie d'un mouvement bancaire, remises bancaires.
export const ACCOUNTING_BUDGET_HELP_PAGE_PATH = `${ACCOUNTING_BUDGET_PAGE_PATH}/aide`;
export const ACCOUNTING_SETTINGS_HELP_PAGE_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/aide`;
export const ACCOUNTING_BRIDGE_HELP_PAGE_PATH = `${ACCOUNTING_SETTINGS_BRIDGE_PATH}/aide`;
export const ACCOUNTING_MOVEMENT_HELP_PAGE_PATH = `${ACCOUNTING_MOVEMENTS_PAGE_PATH}/aide`;
export const ACCOUNTING_SETTLEMENTS_HELP_PAGE_PATH = `${ACCOUNTING_SETTLEMENTS_PAGE_PATH}/aide`;
// Guide de la fusion d'une saisie avec la ligne importée par Bridge, ouvert depuis les propositions de fusion.
export const ACCOUNTING_FUSION_HELP_PAGE_PATH = `${ACCOUNTING_MOVEMENT_HELP_PAGE_PATH}/fusion`;
export const RULES_PAGE_PATH = `${PARAMETER_PATH}/regles`;
export const RULE_NEW_PATH = `${RULES_PAGE_PATH}/nouveau`;
export const RULE_EDIT_PATH = `${RULES_PAGE_PATH}/:ruleId`;
export const getRuleEditPath = (ruleId: string) => `${RULES_PAGE_PATH}/${ruleId}`;
export const BATCH_RULE_EXECUTION_PATH = `${EMPLOYEES_PAGE_PATH}/batch-rule`;
export const TASK_MANAGER_PAGE_PATH = "/gestionnaire-projet";

// Visio routes
export const VISIO_PAGE_PATH = "/visio";
export const VISIO_ROOM_PATH = `${VISIO_PAGE_PATH}/:id`;
export const VISIO_PUBLIC_PATH = `${VISIO_PAGE_PATH}/all`;
export const getVisioRoomPath = (id: string) => `${VISIO_PAGE_PATH}/${id}`;
export const VISIO_ROOM_STANDALONE_PATH = `${VISIO_ROOM_PATH}/onglet`;
export const VISIO_PUBLIC_STANDALONE_PATH = `${VISIO_PUBLIC_PATH}/onglet`;
export const getVisioRoomStandalonePath = (id: string) => `${getVisioRoomPath(id)}/onglet`;

export const PUSH_NOTIFICATIONS_PAGE_PATH = "/notifications-push";
export const OPEN_QUESTIONS_PAGE_PATH = "/assistant";

export const LEGAL_QUESTIONS_PAGE_PATH = "/questions-juridiques";
export const LEGAL_QUESTION_DETAIL_PATH = "/questions-juridiques/:questionId";
export const getLegalQuestionDetailPath = (questionId: string) =>
  `/questions-juridiques/${questionId}`;

// Refunds routes
export const REFUNDS_CONFIGURATION_PATH = "/remboursements/configuration";
// Guide élu du module Remboursement (configuration et traitement des demandes).
export const REFUNDS_HELP_PAGE_PATH = `${REFUND_REQUESTS_PAGE_PATH}/aide`;

export const SMS_ADMIN_PAGE_PATH = "/sms";

export const DEALS_PAGE_PATH = "/bons-plans";
export const DEALS_CATALOGUE_DETAIL_PATH = `${DEALS_PAGE_PATH}/:catalogueSlug`;
export const DEALS_CATALOGUE_GENRES_PATH = `${DEALS_CATALOGUE_DETAIL_PATH}/genres`;
export const DEALS_CATALOGUE_FAMILIES_PATH = `${DEALS_CATALOGUE_DETAIL_PATH}/familles`;
export const DEALS_CATALOGUE_REFERENCES_PATH = `${DEALS_CATALOGUE_DETAIL_PATH}/references`;
export const DEALS_CATALOGUE_PARTNER_OFFERS_PATH = `${DEALS_CATALOGUE_DETAIL_PATH}/offres-partenaires`;
export const DELIVERY_MODES_PAGE_PATH = "/bons-plans/modes-de-livraison";
// Help center & helpdesk routes
export const HELP_CENTER_PATH = "/aide";
export const HELP_CENTER_CATEGORY_PATH = `${HELP_CENTER_PATH}/rubriques/:categoryId`;
export const HELP_CENTER_ARTICLE_PATH = `${HELP_CENTER_PATH}/articles/:articleId`;
export const HELPDESK_TICKETS_PATH = `${HELP_CENTER_PATH}/tickets`;
export const buildHelpCenterCategoryPath = (categoryId: string) =>
  HELP_CENTER_CATEGORY_PATH.replace(":categoryId", categoryId);
export const buildHelpCenterArticlePath = (articleId: string) =>
  HELP_CENTER_ARTICLE_PATH.replace(":articleId", articleId);

// Chat route
export const CHAT_PAGE_PATH = "/communication/chat";

// Communication routes
export const COMMUNICATION_ROOT_PATH = "/communication";
export const COMMUNICATION_DISCUSSIONS_PATH = `${COMMUNICATION_ROOT_PATH}/discussions`;

// Communication Newsletter routes
export const COMMUNICATION_NEWSLETTERS_PATH = `${COMMUNICATION_ROOT_PATH}/newsletters`;
export const COMMUNICATION_NEWSLETTER_NEW_PATH = `${COMMUNICATION_NEWSLETTERS_PATH}/new`;
export const COMMUNICATION_NEWSLETTER_EDITOR_PATH = `${COMMUNICATION_NEWSLETTERS_PATH}/:id/edit`;
export const getCommunicationNewsletterEditorPath = (id: string) =>
  `${COMMUNICATION_NEWSLETTERS_PATH}/${id}/edit`;

// Communication Campaign Report routes
export const COMMUNICATION_CAMPAIGN_REPORTS_PATH = `${COMMUNICATION_NEWSLETTERS_PATH}/campagnes`;
export const COMMUNICATION_CAMPAIGN_REPORT_DETAIL_PATH = `${COMMUNICATION_CAMPAIGN_REPORTS_PATH}/:campaignId`;
export const getCommunicationCampaignReportDetailPath = (campaignId: string) =>
  `${COMMUNICATION_CAMPAIGN_REPORTS_PATH}/${campaignId}`;

// Communication Discussion Detail route
export const COMMUNICATION_DISCUSSION_DETAIL_PATH = `${COMMUNICATION_DISCUSSIONS_PATH}/:discussionId`;
export const getCommunicationDiscussionPath = (discussionId: string) =>
  `${COMMUNICATION_DISCUSSIONS_PATH}/${discussionId}`;

// Communication Saved Replies routes
export const COMMUNICATION_REPLIES_PATH = `${COMMUNICATION_ROOT_PATH}/reponses`;

// Communication CSE Messages routes
export const COMMUNICATION_CSE_MESSAGES_PATH = `${COMMUNICATION_ROOT_PATH}/messages-accueil`;
export const COMMUNICATION_CSE_MESSAGE_NEW_PATH = `${COMMUNICATION_CSE_MESSAGES_PATH}/new`;
export const COMMUNICATION_CSE_MESSAGE_EDITOR_PATH = `${COMMUNICATION_CSE_MESSAGES_PATH}/:id/edit`;
export const getCommunicationCseMessageEditorPath = (id: string) =>
  `${COMMUNICATION_CSE_MESSAGES_PATH}/${id}/edit`;

// Subsidy routes
export const SUBSIDY_ROOT_PATH = "/subventions";
export const SUBSIDY_POLICIES_PAGE_PATH = `${SUBSIDY_ROOT_PATH}/politiques`;
/**
 * A subsidy policy has no page of its own: the tree page owns both the list and the
 * details panel, and selects a policy from this query param at mount. The `/nouveau` and
 * `/:policyId` paths that used to be declared here were never mounted, so any link built
 * from them resolved to a 404.
 */
export const SUBSIDY_POLICY_PARAM = "policyId";
export const getSubsidyPolicyPath = (policyId: string) =>
  `${SUBSIDY_POLICIES_PAGE_PATH}?${SUBSIDY_POLICY_PARAM}=${encodeURIComponent(policyId)}`;
export const SUBSIDY_LEDGER_PAGE_PATH = `${SUBSIDY_ROOT_PATH}/utilisation`;
export const SUBSIDY_CREDITS_PAGE_PATH = `${SUBSIDY_ROOT_PATH}/credits`;
// Activités : rattaché à la Comptabilité (flux par salarié). Ancien path conservé
// pour redirection (liens / favoris).
export const ACTIVITY_OPERATIONS_PAGE_PATH = "/accounting/activites";
export const LEGACY_ACTIVITY_OPERATIONS_PAGE_PATH = `${SUBSIDY_ROOT_PATH}/activites`;
export const INVOICE_DETAIL_PATH = `${ACTIVITY_OPERATIONS_PAGE_PATH}/factures/:invoiceId`;
export const getInvoiceDetailPath = (invoiceId: string) =>
  `${ACTIVITY_OPERATIONS_PAGE_PATH}/factures/${invoiceId}`;

// Changelogs
export const CHANGELOGS_PAGE_PATH = "/nouveautes";

// E-commerce orders (Bons Plans CSE)
export const ECOM_ORDERS_PAGE_PATH = "/bons-plans/demandes";
export const ECOM_ORDER_DETAIL_PATH = "/bons-plans/demandes/:orderId";

// Locations (Core::Catalog)
export const YEATI_LOC_PATH = "/locations";
export const YEATI_LOC_CATALOGUE_PATH = `${YEATI_LOC_PATH}/catalogue`;
export const YEATI_LOC_NEW_PRODUCT_PATH = `${YEATI_LOC_CATALOGUE_PATH}/nouveau`;
export const YEATI_LOC_PRODUCT_DETAIL_PATH = `${YEATI_LOC_CATALOGUE_PATH}/:id`;
export const YEATI_LOC_RESERVATIONS_PATH = `${YEATI_LOC_PATH}/reservations`;
export const YEATI_LOC_BOOKING_DETAIL_PATH = `${YEATI_LOC_RESERVATIONS_PATH}/:bookingId`;
export const YEATI_LOC_PLANNING_PATH = `${YEATI_LOC_PATH}/planning`;
export const YEATI_LOC_COLLECTIONS_PATH = `${YEATI_LOC_PATH}/collections`;
export const YEATI_LOC_SETTINGS_PATH = `${YEATI_LOC_PATH}/parametres`;
export const YEATI_LOC_HELP_PAGE_PATH = `${YEATI_LOC_CATALOGUE_PATH}/aide`;
export const getYeatiLocProductDetailPath = (id: string) =>
  `${YEATI_LOC_CATALOGUE_PATH}/${id}`;
export const getYeatiLocBookingDetailPath = (bookingId: string) =>
  `${YEATI_LOC_RESERVATIONS_PATH}/${bookingId}`;

export const CLASSIFIED_ADS_PATH = "/petites-annonces";

export const ACCOUNTING_SETTINGS_CATEGORIES_PATH = `${ACCOUNTING_SETTINGS_PAGE_PATH}/categories`;
